var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-group", class: { fake: _vm.fake } },
    [
      !_vm.fake
        ? _c("div", { staticClass: "documents-group__header" }, [
            _c(
              "div",
              { staticClass: "documents-group__data" },
              [
                _c("toggle-button", {
                  staticClass: "documents-group__toggler",
                  attrs: { disabled: _vm.noDocumentsInGroup },
                  model: {
                    value: _vm.isOpen,
                    callback: function ($$v) {
                      _vm.isOpen = $$v
                    },
                    expression: "isOpen",
                  },
                }),
                _c("div", { staticClass: "documents-group__info" }, [
                  _c("div", { staticClass: "documents-group__name" }, [
                    _vm._v(" " + _vm._s(_vm.group.name) + " "),
                    _vm.hasColorMarks
                      ? _c(
                          "div",
                          { staticClass: "documents-group__colors" },
                          [
                            _vm.group.absent_color
                              ? _c("document-issue-mark", {
                                  staticClass: "documents-group__color",
                                  attrs: {
                                    issue: "absent",
                                    color: _vm.group.absent_color,
                                  },
                                })
                              : _vm._e(),
                            _vm.group.expired_color
                              ? _c("document-issue-mark", {
                                  staticClass: "documents-group__color",
                                  attrs: {
                                    issue: "expired",
                                    color: _vm.group.expired_color,
                                  },
                                })
                              : _vm._e(),
                            _vm.group.expiring_color
                              ? _c("document-issue-mark", {
                                  staticClass: "documents-group__color",
                                  attrs: {
                                    issue: "expiring",
                                    color: _vm.group.expiring_color,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm.group.description
                    ? _c(
                        "div",
                        { staticClass: "documents-group__description" },
                        [_vm._v(" " + _vm._s(_vm.group.description) + " ")]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "documents-group__actions" },
              [
                _vm.group.id !== 9999
                  ? _c("c-button-2", {
                      staticClass: "documents-group__edit",
                      attrs: { size: "iconic", icon: "edit" },
                      on: { click: _vm.onEdit },
                    })
                  : _vm._e(),
                _vm.group.id !== 9999
                  ? _c("c-button-2", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            boundary: "window",
                            content: _vm.getToolTipTitle,
                            placement: "top",
                          },
                          expression:
                            "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: getToolTipTitle,\n          placement: 'top',\n        }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "documents-group__edit",
                      attrs: { size: "iconic", icon: "box-arhive" },
                      on: { click: _vm.onGroupArchive },
                    })
                  : _vm._e(),
                _vm.group.docs.length > 0 && _vm.group.id !== 9999
                  ? _c(
                      "span",
                      {
                        staticClass: "documents-group__remove",
                        attrs: { id: `document-group-remove-${_vm.group.id}` },
                      },
                      [
                        _c("c-button-2", {
                          attrs: {
                            icon: { icon: "trash", color: "secondary" },
                            size: "iconic",
                            disabled: "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.group.docs.length === 0 && _vm.group.id !== 9999
                  ? _c("c-button-2", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            boundary: "window",
                            content: "Удалить",
                            placement: "top",
                          },
                          expression:
                            "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "documents-group__remove",
                      attrs: {
                        icon: { icon: "trash", color: "secondary" },
                        size: "iconic",
                      },
                      on: { click: _vm.onRemove },
                    })
                  : _vm._e(),
                _c(
                  "b-popover",
                  {
                    attrs: {
                      placement: "top",
                      triggers: "hover blur",
                      target: `document-group-remove-${_vm.group.id}`,
                    },
                  },
                  [
                    _c("error-feedback", {
                      staticClass: "m-0 empty-category-tooltip",
                      attrs: {
                        text: "В данный момент удаление невозможно, так как тип содержит документы. Сначала перенесите все документы из типа.",
                      },
                    }),
                  ],
                  1
                ),
                _c("c-button-2", {
                  staticClass: "documents-group__move",
                  attrs: { size: "iconic", icon: "arrows-constructor" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "slide-up-down",
        {
          staticClass: "documents-group__items",
          attrs: {
            active: _vm.isOpen || _vm.noDocumentsInGroup,
            duration: 400,
          },
        },
        [
          _c(
            "draggable",
            {
              staticClass: "item-sub item-container",
              attrs: {
                group: "type",
                list: _vm.group.docs,
                move: _vm.onMove,
                "force-fallback": true,
                "ghost-class": "sortable__ghost",
              },
            },
            _vm._l(_vm.group.docs, function (document) {
              return _c(
                "div",
                { key: document.id },
                [
                  _c("document-item", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isDocumentVisible(document),
                        expression: "isDocumentVisible(document)",
                      },
                    ],
                    attrs: { document: document, selectedTab: _vm.selectedTab },
                    on: {
                      remove: function ($event) {
                        return _vm.onDocumentRemove(document)
                      },
                      archive: function ($event) {
                        return _vm.onDocumentArchive(document)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }